const appInfo = {
    appName: 'Fashion Cloud',
    appCss: '',
    appLogo: {
        small: '/assets/img/fc_logo_cloud_black.svg',
        medium: '/assets/img/fc_logo_black.svg',
        original: '/assets/img/fc_logo_black.svg',
        smallWhite: '/assets/img/fc_logo_white.svg',
        newSignin: '/assets/img/fc_logo_signin.svg',
        signup: '/assets/img/fc_logo_signup.svg'
    },
    appImagesDir: '',
    appLanguage: '',
    appDomain: '',
    appExternalLink: 'http://fashion.cloud',
    appPlaceholder: '',
    supportEmail: 'support@fashion.cloud'
};

export function getAppDomain() {
    return appInfo.appDomain;
}

export function getAppName() {
    return appInfo.appName;
}

export function getAppCss() {
    return appInfo.appCss;
}

export function getAppLogo() {
    return appInfo.appLogo;
}

export function getAppLanguage() {
    return appInfo.appLanguage;
}

export function getAppImagesDir() {
    return appInfo.appImagesDir;
}

export function getAppPlaceholder() {
    return appInfo.appPlaceholder;
}

export function getAppExternalLink() {
    return appInfo.appExternalLink;
}

export function getSupportEmail() {
    return appInfo.supportEmail;
}
